import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MaterialModule } from '@app/material.module'
import { SharedModule } from '@shared/shared.module'
import { ConfirmComponent } from './confirm/confirm.component'
import { InfoComponent } from './info/info.component'
import { InputComponent } from './input/input.component'
import { ListFilesComponent } from './list-files/list-files.component'
import { TextAreaComponent } from './text-area/text-area.component'

@NgModule({
  declarations: [InfoComponent, ConfirmComponent, InputComponent, TextAreaComponent, ListFilesComponent],
  imports: [CommonModule, MaterialModule, SharedModule],
})
export class ModalModule {}
